import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch, nextTick } from 'vue'
  import HTMLRenderer from '@/components/common/HTMLRenderer.vue'
  import TextRenderer from '@/components/editor/TextRenderer.vue'
  import useEditor from '@/composables/useEditor'
  import useI18n from '@/composables/useI18n'
  import type { PropType } from 'vue'
  import type { Nullable } from '@/services/interfaces/QuizQuestion'
  import type { EditorStatePayload } from '@/services/interfaces/Course'
  import { useRoute } from 'vue-router/composables'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'VideoTranscript',
  props: {
    videoTranscript: {
      type: String,
      required: true,
    },
    mutateAndQueueFunc: Function as PropType<(data: EditorStatePayload) => void>,
  },
  setup(__props) {

  

  const { translateString } = useI18n()
  const route = useRoute()
  const { inEditorMode } = useEditor(route)

  const videoTranscriptElement = ref(null as Nullable<HTMLDivElement>)
  const shouldClampTranscript = ref(false)
  const transcriptClamped = ref(false)

  const showAllOrLess = computed(() => {
    return transcriptClamped.value
      ? translateString('courses.videoTranscript.showAll')
      : translateString('courses.videoTranscript.showLess')
  })

  watch(inEditorMode, (value) => {
    if (!value) {
      nextTick(() => {
        clampVideoTranscript()
      })
    }
  })

  const clampVideoTranscript = () => {
    if (videoTranscriptElement.value) {
      const { height } = (videoTranscriptElement.value.firstChild as HTMLElement).getBoundingClientRect()
      shouldClampTranscript.value = height > 40
      if (shouldClampTranscript.value) {
        transcriptClamped.value = true
      }
    }
  }

  const toggleTranscriptClamp = () => {
    transcriptClamped.value = !transcriptClamped.value
  }

  onMounted(() => {
    clampVideoTranscript()
  })

return { __sfc: true,translateString, route, inEditorMode, videoTranscriptElement, shouldClampTranscript, transcriptClamped, showAllOrLess, clampVideoTranscript, toggleTranscriptClamp, computed, onMounted, ref, watch, nextTick, HTMLRenderer, TextRenderer, useEditor, useI18n, useRoute }
}

})